import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PETITION_PAGE_FULL_SUNRISE = createFcmDetails('petition_page_full_sunrise', {
	owner: 'vaquita-squad',
	context: 'Petition details',
	description:
		'FC to control the full sunrise migration for the petition page and any related experiments for each module',
	template: {
		petitionDescription: { enabled: false, experimentName: '' },
		supporters: { enabled: false, experimentName: '' },
		recentSigners: { enabled: false, experimentName: '' },
		promotedPetitions: { enabled: false, experimentName: '' },
		contentSummary: { enabled: false, experimentName: '' },
		petitionStarter: { enabled: false, experimentName: '' },
	},
	import: false,
});
